/**
 * CENTRALIZED IMAGE CONFIGURATION
 *
 * To use local images from the public folder:
 * 1. Place your image in /public/assets/images/
 * 2. Change the value below to '/assets/images/your-file.jpg'
 */
export const IMAGE_ASSETS = {
  // BRANDING (Logo & Browser Tab Icon)
  logo: "https://media-manager-c.questera.ai/greta-media/514d4f1b1e2f05ce7031b6b87da7e449a93e9ab16c3b258397e3cd4942f554c2dbbdd8a0436dc6e9cf4cc142a2e9f09d/images/aW1hZ2UvcG5n/8e518e03acfd7b6878804056da42b62f.png",
  icon: "https://media-manager-c.questera.ai/greta-media/514d4f1b1e2f05ce7031b6b87da7e449a93e9ab16c3b258397e3cd4942f554c2dbbdd8a0436dc6e9cf4cc142a2e9f09d/images/aW1hZ2UvcG5n/8e518e03acfd7b6878804056da42b62f.png",

  // HERO & BACKGROUNDS
  hero: "https://images.unsplash.com/photo-1595854341625-f33ee10dbf94?q=80&w=2069&auto=format&fit=crop",
  aboutStory: "https://images.unsplash.com/photo-1556740714-a8395b3bf30f?auto=format&fit=crop&q=80&w=800",

  // MENU ITEMS
  burger: "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?auto=format&fit=crop&q=80&w=400",
  wings: "https://images.unsplash.com/photo-1567620832903-9fc6debc209f?auto=format&fit=crop&q=80&w=400",
  beer: "https://images.unsplash.com/photo-1535958636474-b021ee887b13?auto=format&fit=crop&q=80&w=400",

  // PAGE FEATURES
  poolTable: "https://images.unsplash.com/photo-1574163012975-f5be8e9d4076?auto=format&fit=crop&q=80&w=800",

  // GALLERY
  gallery: [
    "https://images.unsplash.com/photo-1595854341625-f33ee10dbf94?auto=format&fit=crop&q=80&w=600",
    "https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?auto=format&fit=crop&q=80&w=600",
    "https://images.unsplash.com/photo-1574163012975-f5be8e9d4076?auto=format&fit=crop&q=80&w=600",
    "https://images.unsplash.com/photo-1561758033-d89a9ad46330?auto=format&fit=crop&q=80&w=600",
    "https://images.unsplash.com/photo-1583262799307-e85dfeb01db6?auto=format&fit=crop&q=80&w=600",
    "https://images.unsplash.com/photo-1556740714-a8395b3bf30f?auto=format&fit=crop&q=80&w=600",
  ]
};